import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shield, security, protection"} maskId="square-filled-radius-0-stroke-1-IconShield"><path d="M12 1.97461L3 4.88637V11.9125C3 14.5727 4.21165 16.5925 5.90547 18.2031C7.58545 19.8004 9.76777 21.0219 11.7626 22.0981L12 22.2262L12.2374 22.0981C14.2322 21.0219 16.4145 19.8004 18.0945 18.2031C19.7883 16.5925 21 14.5727 21 11.9125V4.88637L12 1.97461Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShield;
